var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1677,
    height: 896,
    viewBox: "0 0 1677 896",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1677,
    height: 896,
    fill: "#FED2C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352 385.5L1015.5 327.5L1032 503L355 421L352 385.5Z",
    fill: "#B8CAD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M356 419L1083.5 509L1056.5 571.5L1036 542.5L1025 568L1003.5 538.5L992.5 563.5L972 534.5L960.5 558L940 530L928.5 555L907.5 526.5L896.5 551L876.5 522.5L864 547L844 518.5L832 543L812 514L800.5 539L780 510L768.5 534.5L748.5 506.5L735.5 530.5L716 502L704 526L684 498L671.5 522.5L652 494.5L640 518.5L620 490.5L608.5 514.5L587.5 486L575.5 511.5L555.5 482L544.5 509L524 478L512 502L491.5 474L480 499L460.5 471L448 494.5L428 466.5L415.5 490.5L396.5 462.5L384 486L365.5 460L360 457.5L356 419Z",
    fill: "#92A3AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1205 317L1192.5 349L1205 369L1216 391L1228 423L1233.5 445.5L1236.5 468.5L1238.5 489.5L1240 512.5L1271 548L1086.5 564.5L973.5 463.5L962 337.5L982.5 317L1216 296L1205 317ZM1128.98 339.76L1084.47 341.04C1076.48 341.27 1070.94 349.099 1073.39 356.708L1123.93 513.942C1125.71 519.474 1131.19 522.937 1136.95 522.163L1179.8 516.407C1187.21 515.413 1191.91 507.97 1189.63 500.856L1140.75 348.098C1139.12 343.006 1134.32 339.606 1128.98 339.76ZM1009 438C1000.16 438 993 445.163 993 454C993 462.837 1000.16 470 1009 470C1017.84 470 1025 462.837 1025 454C1025 445.163 1017.84 438 1009 438ZM997 342C988.163 342 981 349.163 981 358C981 366.837 988.163 374 997 374C1005.84 374 1013 366.837 1013 358C1013 349.163 1005.84 342 997 342Z",
    fill: "#A71D12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1280 532C1280 544 1277.06 548 1268.5 548C1259.94 548 1241 540.627 1241 534C1241 527.373 1230.44 511.5 1239 511.5C1247.56 511.5 1266 504.5 1280 532Z",
    fill: "#A71D12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1239 322.5C1239 337.136 1227.81 349 1214 349C1200.19 349 1167.5 352.136 1167.5 337.5C1167.5 322.864 1200.19 296 1214 296C1227.81 296 1239 307.864 1239 322.5Z",
    fill: "#A71D12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaw);
export default __webpack_public_path__ + "static/media/saw.7a2c94a2a1ef1d83bcbd8a9d2c5ff2db.svg";
export { ForwardRef as ReactComponent };